<template>
    <Transition>
        <div class="loader" v-if="isShow > 0">
            <div>
                <SquareGrid></SquareGrid>
                <label>{{msg}}</label>
            </div>
        </div>
    </Transition>
</template>

<script>
    import { getCurrentInstance } from 'vue';
    import SquareGrid from './SquareGrid.vue';
    //import RotateSquare from './RotateSquare.vue';

    export default {
        props: {
            message: {
                default: 'Please Wait.'
            }
        },
        components: {
            SquareGrid,
            //RotateSquare
        },
        mounted() {
            const app = getCurrentInstance();
            app.appContext.config.globalProperties.$loader = this;
        },
        data() {
            return {
                isShow: 0,
                msg: this.message,
                callers: []
            }
        },
        methods: {
            uuid() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                );
            },
            show(message, hideInSeconds) {
                let id = this.uuid();
                this.msg = (message === null || message === undefined || message == '') ? this.message : message;
                this.isShow++;

                if (0 < hideInSeconds) {
                    const timer = setTimeout(() => {
                        this.hide(id);
                    }, hideInSeconds * 1000);
                    this.callers.push({ 'key': id, timer: timer });
                }

                return id;
            },
            hide(key) {
                if (key === null || key === undefined) {
                    this.hideAll();
                } else {

                    let n = -1;
                    for (n = 0; n < this.callers.length; n++) {
                        let x = this.callers[n];
                        if (x.key == key) {
                            setTimeout(() => {
                                this.isShow--;
                            }, 500);

                            if (x.timer != null) {
                                clearTimeout(x.timer);
                                x.timer = null;
                            }

                            break;
                        }
                    }

                    if (n > -1) {
                        this.callers.splice(n, 1);
                    }
                }
            },
            hideAll() {
                this.isShow = 0;
                while (1 > this.callers.length) {
                    let x = this.callers.shift();
                    if (x.timer != null) {
                        clearTimeout(x.timer);
                        x.timer = null;
                    }
                }

                this.callers.splice(0, this.callers.length);
            }
        },
        computed: {}
    }
</script>

<style scoped>
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }

    .loader {
        min-width: 100vw;
        min-height: 100vh;
        background-color: rgba(0,0,0,0.7);
        display: table;
        vertical-align: middle;
        position: fixed;
        left: 0px;
        top: 0px;
        z-index: 9999999;
    }

        .loader > div {
            display: table-cell;
            vertical-align: middle;
            text-align: center;
            color: #fff;
            text-shadow: rgba(100,100,100,0.5);
        }

</style>